import { useNavigate } from "react-router-dom";
import { Panel } from "@/components/Panel";
import { useLocationOverview } from "@/api/inventory";

export function LocationOverview() {
  const navigate = useNavigate();
  const { data: rows = [], isLoading } = useLocationOverview();

  return (
    <Panel
      title="Lagerorte"
      subtitle={`${rows.length} Bereiche · Belegung relativ zum staerksten Bereich`}
    >
      {isLoading ? (
        <div className="text-sm text-muted">Lade Lager-Aggregate…</div>
      ) : rows.length === 0 ? (
        <div className="text-center text-sm text-muted py-10">
          Keine Lagerorte hinterlegt.
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          {rows.map((r) => {
            const barColor =
              r.fill_pct > 85 ? "bg-warn" : r.fill_pct > 50 ? "bg-primary" : "bg-success";
            return (
              <button
                key={r.area}
                type="button"
                onClick={() => navigate(`/catalog?location=${encodeURIComponent(r.area)}`)}
                className="text-left rounded-md border border-line bg-panel p-4 hover:border-primary/60 transition-colors"
              >
                <div className="font-semibold text-sm text-ink truncate">{r.area || <span className="italic text-muted">— leer —</span>}</div>
                <div className="flex items-baseline gap-1.5 mt-2">
                  <span className="font-mono text-2xl font-bold text-ink">{r.fill_pct}%</span>
                  <span className="text-[11px] text-muted">Auslastung (rel.)</span>
                </div>
                <div className="mt-2 h-1.5 bg-panel-2 rounded overflow-hidden">
                  <div
                    className={`h-full rounded ${barColor}`}
                    style={{ width: `${r.fill_pct}%` }}
                  />
                </div>
                <div className="mt-3 flex justify-between text-[11px] text-muted">
                  <span>{r.distinct_items} SKUs</span>
                  <span className="font-mono">{r.total_quantity.toLocaleString("de-DE")} Stk.</span>
                </div>
              </button>
            );
          })}
        </div>
      )}
      <div className="mt-3 text-[11px] text-muted italic">
        Klick auf einen Bereich filtert den Produktkatalog auf diesen Lagerort.
      </div>
    </Panel>
  );
}
